import { render, staticRenderFns } from "./extranetDetail.vue?vue&type=template&id=09aa0636&scoped=true&"
import script from "./extranetDetail.vue?vue&type=script&lang=js&"
export * from "./extranetDetail.vue?vue&type=script&lang=js&"
import style0 from "./extranetDetail.vue?vue&type=style&index=0&id=09aa0636&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09aa0636",
  null
  
)

export default component.exports